import React, {Component} from 'react';
import Big from 'big.js';

export function isBigNumberValid(input = '') {
    try {
        Big(input);
        return true;
    }
    catch (err) {
        return false;
    }
}

export function formatNumber(oriAmount, dp = 2, dp2 = undefined, withComma = true, fallbackVal = 0) {
    // remove commas from strings eg "2,300", as this will cause error when converting to Big
    const amount = typeof oriAmount === 'string' ? oriAmount.replace(/,/g, '') : oriAmount;

    // No amount
    if (amount === null || amount === undefined || amount === '')
        return null;

    // deal with invalids such as NaN or invalid strings eg: 'abc12
    const fallbackValIsNumber = typeof fallbackVal === 'number';
    if (!isBigNumberValid(amount) && !fallbackValIsNumber)
        return fallbackVal;

    const bigAmount = new Big(isBigNumberValid(amount) ? amount : fallbackVal);
    // Extended decimal points, eg: 2,4
    let endDp = dp;
    let bigAmountRounded = bigAmount.round(endDp);
    if (dp2 !== undefined) { // Extended
        for (let i = dp + 1; i <= dp2; i += 1) { // 3,4
            if (bigAmountRounded.cmp(bigAmount.round(i)) !== 0) {
                endDp = i;
                bigAmountRounded = bigAmount.round(i);
            }
        }
    }

    // withComma ==> adds comma to every thousands eg: 2000000.00 => 2,000,000.00
    const stringAmount = bigAmount.toFixed(endDp);
    return withComma ? stringAmount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : stringAmount;
}

/**
 * Format the number with commas, decimal points and currency
 *
 * Props
 * - amount (required)
 * - currency (string)
 * - dp (int, default to 2)
 * - dp2 (int, extended decimal points)
 **/
class FormatNumber extends Component {
    render() {
        const {
            currency,
            amount,
            dp,
            dp2,
            suffix,
            id,
            onChange,
            emptyText,
            style,
            amountDefined,
            spaceBetweenCurrencyAndAmount = true,
            ...restProps
        } = this.props;

        // No amount
        if (amount === null || amount === undefined || amount === '')
            return emptyText !== undefined ? emptyText : '-';

        return (
            // amountDefined is only passed from AmountBank component (for batch payments)
            amountDefined === false ?
                <React.Fragment {...restProps}>
                    <span style={style}>
                        { currency }
                        { spaceBetweenCurrencyAndAmount ? ' ' : '' }
                        { formatNumber(amount, (dp || dp === 0) ? dp : 2, dp2) }
                    </span>
                    <span>
                        { suffix }
                    </span>
                </React.Fragment>
                :
            // amountDefined is true/undefined:
                <React.Fragment {...restProps}>
                    { currency }
                    { spaceBetweenCurrencyAndAmount ? ' ' : '' }
                    { formatNumber(amount, (dp || dp === 0) ? dp : 2, dp2) }
                    { suffix }
                </React.Fragment>
        );
    }
}
export default FormatNumber;
